import { render, staticRenderFns } from "./GfFrpLeaderboard.vue?vue&type=template&id=3cab9cb1&scoped=true&lang=html&"
import script from "./GfFrpLeaderboard.vue?vue&type=script&lang=js&"
export * from "./GfFrpLeaderboard.vue?vue&type=script&lang=js&"
import style0 from "./GfFrpLeaderboard.vue?vue&type=style&index=0&id=3cab9cb1&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cab9cb1",
  null
  
)

export default component.exports